<template>
	<Tag
		:text="text"
		:background="background"
		icon-name="dot"
		:class="['status-tag', `status--${background}`]"
		data-test="status-tag"
	/>
</template>

<script lang="ts">
export default {
	name: 'StatusTag'
};
</script>

<script setup lang="ts">
import Tag from '@components/tags/tag-component.vue';
import { TagBackground } from 'types/layout';

interface Props {
	text: string;
	background?: TagBackground;
}
withDefaults(defineProps<Props>(), {
	background: 'default'
});
</script>

<style lang="scss">
@use '../../styles/constants/colors.scss' as *;
@use 'sass:map';

.status-tag {
	.svg-icon {
		height: 6px;
		width: 6px;
	}

	&.status--green .svg-icon {
		color: map.get($brand-colors, 'green');
	}
	&.status--default .svg-icon,
	&.status--white .svg-icon {
		color: map.get($brand-colors, 'gray-40');
	}
	&.status--blue .svg-icon {
		color: token('data-secondary-dark');
	}
	&.status--red .svg-icon {
		color: map.get($brand-colors, 'red');
	}
	&.status--gold-light .svg-icon {
		color: map.get($brand-colors, 'gold-dark');
	}
}
</style>
